import { configureStore } from '@reduxjs/toolkit'
import { todosSlice } from './todos';
import { authSlice } from './auth';
import { userSlice } from './user';
import { tasksSlice } from './tasks';
import { projectsSlice } from './projects';
import { settingsSlice } from './settings';
import { mqttSlice } from './mqtt';

export const store = configureStore({
    reducer: {
        [todosSlice.reducerPath]: todosSlice.reducer,
        [userSlice.reducerPath]: userSlice.reducer,
        [authSlice.reducerPath]: authSlice.reducer,
        [tasksSlice.reducerPath]: tasksSlice.reducer,
        [projectsSlice.reducerPath]: projectsSlice.reducer,
        [settingsSlice.reducerPath]: settingsSlice.reducer,
        [mqttSlice.reducerPath]: mqttSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
        todosSlice.middleware,
        userSlice.middleware,
        authSlice.middleware,
        tasksSlice.middleware,
        projectsSlice.middleware,
    ),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
